import { Box } from "@mui/material";

export const WebcomLogo = () => (
  <Box
    component="svg"
    viewBox="0 0 168 36"
    sx={{
      display: "block",
      width: 168,
      height: 36,
    }}
  >
    <use xlinkHref="#webcom-logo-with-bg" />
  </Box>
);
